export default __webpack_public_path__ + "static/c20b47a9-1a1a-463a-9d07-c0a8563d27f1-9b72480653000dc96d3d07411a019b08.jpg";